import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const taskList = {
    colorNumber: '#139cd9',
    list: [
        'Создать платформу, на&nbsp;которой будет возможно конвертировать даже специфические файлы, которые редко используются. Поэтому мы&nbsp;много внимания уделяем количеству поддерживаемых форматов. Сейчас их&nbsp;более 230, но&nbsp;на&nbsp;этом мы&nbsp;не&nbsp;останавливаемся и&nbsp;еженедельно работаем над подключением новых.',
        'Отладить процесс так, чтобы на&nbsp;платформе можно было быстро и&nbsp;качественно конвертировать большие файлы любых форматов. Например, конвертация видео-файлов требует много ресурсов, тонкого подхода к&nbsp;выбору железа и&nbsp;настройке алгоритмов.',
        'Внедрить сервисы распознавания текстов. Часто при конвертации мы&nbsp;сталкиваемся с&nbsp;задачей преобразования jpg в&nbsp;word. В&nbsp;2020 году мы&nbsp;планируем запуск сервиса, который решает эту задачу, причем сразу на&nbsp;всех 15&nbsp;языках, которые поддерживает конвертер.',
    ],
};

const Tasks = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="converter-tasks" bigPaddings={true}>
                <CommonTitle>Задачи</CommonTitle>
                <div className="converter-tasks__wrapper">
                    <div className="converter-tasks__info">
                        <CommonUsualText className="converter-tasks__text">
                            Мы&nbsp;ставим перед собой достаточно амбициозную цель. И&nbsp;чтобы
                            ее&nbsp;достичь, нужно грамотно распределить ресурсы и&nbsp;поставить
                            задачи, которые сделают нас ближе к&nbsp;цели в&nbsp;короткие сроки. Для
                            этого нам нужно:
                        </CommonUsualText>
                    </div>
                    <CommonOlList className="converter-tasks__list" CommonOlList={taskList} />
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
